////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import theme from '../../../theme/theme'
import convertHexToRGBA from '../../../helpers/HexToRgba'

//////STYLED//////
const SalesControlStatusWrapper = styled.div`
	text-align: center;

	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
`
//////STYLED//////

const SalesControlStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<SalesControlStatusWrapper colorCode={props.row.lastSaleValidated === 'common__text__ko' ? theme.colors.error : theme.colors.validation}>
			{translations[props.row.lastSaleValidated]}
		</SalesControlStatusWrapper>
	)
}

SalesControlStatus.propTypes = {}

SalesControlStatus.defaultPropTypes = {}

export default SalesControlStatus
